<template>
  <div class="home">
    <div class="product-title">{{ $t('product-title') }}</div>
    <h1 class="title">
      {{ $t('title') }}
    </h1>
    <h4>
      {{ $t('subtitle') }}
    </h4>
    <one-button
      type="primary"
      class="get-started-btn"
      @click.native="$router.push(localizeUrl('project', $i18n.locale))"
    >
      {{ $t('calculate-cost') }}
    </one-button>
    <img class="hero-image" src="@/assets/calculator.svg" alt="Logo" />
  </div>
</template>

<script>
import { localizeUrl } from "@/utils/localizeUrl";

export default {
  name: "Home",
  components: {},
  methods: {
    localizeUrl: localizeUrl
  }
};
</script>

<style scoped lang="scss">
@import "../common/_variables.scss";
.home {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.title {
  padding-bottom: 40px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}
.get-started-btn {
  margin-top: 20px;
}
.hero-image {
  max-width: 800px;
}
@media only screen and (max-width: 768px) {
  .hero-image {
    margin-top: 10px;
    max-width: 100%;
  }
}
.product-title {
  font-size: 18px;
  font-weight: 600;
  margin-top: 20px;
  margin-bottom: 20px;
  color: $color-primary;
}
</style>
